import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import * as styles from "source/app/presentation/MainPanel/Workflows/BreadCrumbs/BreadCrumbs.css";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { SetRootNodeAsync } from "source/app/services/Workflows/SetRootNode";

export function BreadCrumbs({ rootNode }: { rootNode: IWorkflowNode }) {
    const [state, setState] = React.useState<IWorkflowNode[]>([]);
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        let isActive = true;

        MotwLogicServer.GetPathToHomeNodeAsync(rootNode.id)
            .then((path) => {
                if (!isActive) {
                    return;
                }

                setState(Array.isArray(path) ? path : []);
            })
            .catch(() => {
                if (isActive) {
                    setState([]);
                }
            });

        return () => {
            isActive = false;
        };
    }, [rootNode]);

    React.useLayoutEffect(() => {
        const container = containerRef.current;

        if (container) {
            container.scrollLeft = container.scrollWidth;
        }
    }, [state]);

    ShareState(ESharedFunction.BreadCrumbs_state, state, setState);
    const workflows = GetWorkflowsState();

    if (!workflows) {
        return <div />;
    }

    return (
        <div
            ref={containerRef}
            className={styles.container}
            aria-label="Workflow path"
        >
            {state.map((node, index) => {
                const isCurrentNode = index === state.length - 1;

                return (
                    <React.Fragment key={node.id}>
                        {index > 0 ? (
                            <span className={styles.separator} aria-hidden>
                                ›
                            </span>
                        ) : null}
                        {isCurrentNode ? (
                            <Hyperlink
                                classes={styles.current}
                                whenClicked={() => SetRootNodeAsync(node.id)}
                            >
                                {node.name}
                            </Hyperlink>
                        ) : (
                            <Hyperlink
                                classes={styles.ancestor}
                                whenClicked={() => SetRootNodeAsync(node.id)}
                            >
                                {node.name}
                            </Hyperlink>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
